import { inject, type InjectionKey } from 'vue'
import type { SettingsConfig } from '../config'

export const SETTINGS_CONFIG_KEY: InjectionKey<SettingsConfig> = Symbol('SettingsConfig')

export function useSettingsConfig(): SettingsConfig {
  const config = inject(SETTINGS_CONFIG_KEY)
  if (!config) {
    throw new Error('Settings plugin not installed. Make sure to call app.use(createSettingsPlugin(...))')
  }
  return config
}
